// src/pages/auth/PasswordResetEmail.jsx
import React, { useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axios'; // Adjust path if needed

const { Title } = Typography;

const PasswordResetEmail = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      await axiosInstance.post('accounts/request-token/', {
        email: values.email,
      });

      message.success('Password reset link has been sent to your email!');
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        error.response?.data?.email?.[0] ||
        error.response?.data?.detail ||
        'Failed to send reset link. Please check your email or try again.';

      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
      {/* Logo and branding */}
      <div style={{ textAlign: 'center', marginBottom: 32 }}>
        <div
          style={{
            width: 48,
            height: 48,
            margin: '0 auto 8px',
            backgroundColor: '#6366f1',
            borderRadius: 12,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <span style={{ color: 'white', fontWeight: 'bold' }}>∞</span>
        </div>
        <Title level={3} style={{ marginBottom: 0 }}>
          Welcome to Getam
        </Title>
      </div>

      <div style={{ marginBottom: 24 }}>
        <Title level={4} style={{ margin: 0 }}>
          Forgot Password
        </Title>
        <div style={{ marginTop: 8, color: '#666', fontSize: 14 }}>
          Enter your email and we'll send you a link to reset your password.
        </div>
      </div>

      <Form
        name="reset-password"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Please enter your email!' },
            { type: 'email', message: 'Please enter a valid email!' },
          ]}
        >
          <Input
            size="large"
            placeholder="Enter your registered email"
            style={{ borderRadius: 8 }}
          />
        </Form.Item>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 24,
          }}
        >
          <div></div>
          <Link to="/">← Back to Sign In</Link>
        </div>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
            loading={loading}
            disabled={loading}
            style={{
              backgroundColor: '#6366f1',
              borderColor: '#6366f1',
              borderRadius: 8,
              height: 48,
            }}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default PasswordResetEmail;